import React from "react";
import MedicalAccessoriesPage from "../Components/MedicalAccessories/MedicalAccessoriesPage";

const MedicalAccessories = () => {
  return <MedicalAccessoriesPage />;
};

export default MedicalAccessories;